import { getAuthDataLoader } from './dataLoader';
export async function listMeasurement() {
    const data = await getAuthDataLoader().loadJson('/order/list');
    return data.json;
}
export async function setEnvMeasurement(data) {
    const res = await getAuthDataLoader().postJson('/order/env/set', data);
    return res.json;
}
/* export async function addNewMesurment(data: MesurmentStaticOut): Promise<{
    newObj: MesurmentIn, //  TODO
}> {
    const res = await getAuthDataLoader().postJson('/mes/add', data)
    return res.json;
} */
export async function addNewOrder(mData) {
    const res = await getAuthDataLoader().postJson('/order/add', mData);
    return res.json;
}
export async function validateNewOrder(dbUid) {
    const res = await getAuthDataLoader().postJson('/order/validate', {
        measurement_dbUid: dbUid
    });
    return res.json;
}
export async function exportOrder(mes_index) {
    const res = await getAuthDataLoader().postJson('/order/export', {
        measurement_dbUid: mes_index
    });
    return res.json;
}
export async function listCustomer() {
    const data = await getAuthDataLoader().loadJson('/customer/list');
    return data.json;
}
export async function addNewDataPoint(data) {
    const res = await getAuthDataLoader().postJson('/dataPoint/add', data);
    return res.json;
}
export async function getAppConfig() {
    const data = await getAuthDataLoader().loadJson('/appConfig/get');
    return data.json;
}
export async function listEnvHw() {
    const data = await getAuthDataLoader().loadJson('/hwEquipment/list');
    return data.json;
}
